interface ArrowSelectionProps {
  listReference?: HTMLElement
  onEnter: () => void
  onEscape?: () => void
}

/**
 * ArrowSelection
 * Class to update selected item in list of items with keyboard arrows
 * Props:
 * onEnter (required) - Function to call when user type Enter (and select item)
 * onEscape - Function to call when user type ESC (ex: to close list)
 * listReference - list HTML element to update scroll based on selected item, pass this reference and set index = selectedIndex on HTML
 */
class ArrowSelection {
  private listReference: HTMLElement | undefined
  private onEnter: () => void
  private onEscape?: () => void

  constructor(props: ArrowSelectionProps) {
    this.listReference = props.listReference
    this.onEnter = props.onEnter
    this.onEscape = props.onEscape
  }

  handleKeyDown(
    event: KeyboardEvent,
    listLength: number,
    selectedIndex: number
  ) {
    if (event.key === 'ArrowUp') {
      return this.upHandler(listLength, selectedIndex)
    }

    if (event.key === 'ArrowDown') {
      return this.downHandler(listLength, selectedIndex)
    }

    if (event.key === 'Enter') {
      this.onEnter()
      return false
    }

    if (event.key === 'Escape') {
      if (this.onEscape) this.onEscape()
      return false
    }

    return false
  }

  private upHandler(listLength: number, selectedIndex: number) {
    const index = selectedIndex - 1
    selectedIndex = index < 0 ? listLength - 1 : index
    this.updateSelectPosition(selectedIndex)
    return selectedIndex
  }

  private downHandler(listLength: number, selectedIndex: number) {
    const index = selectedIndex + 1
    selectedIndex = index === listLength ? 0 : index
    this.updateSelectPosition(selectedIndex)
    return selectedIndex
  }

  private updateSelectPosition(selectedIndex: number) {
    if (!this.listReference) return
    this.listReference
      .querySelector(`[index="${selectedIndex}"]`)
      ?.scrollIntoView({ block: 'nearest' })
  }
}

export default ArrowSelection
